import { decodeHTML } from 'entities';

/**
 * Returns the first non-empty string from the provided values.
 * Yoast can emit empty strings for description/og_description, which should fall through to defaults.
 */
export function firstNonEmpty(...values: (string | undefined)[]): string | undefined {
    return values.find((v) => v != null && v !== '');
}

/**
 * WordPress wraps a rendered excerpt in a <p> tag and HTML-encodes entities — strip both for
 * plain-text display.
 */
export function cleanExcerpt(excerpt: string): string {
    return decodeHTML(excerpt.replace(/<\/?p>/g, '')).trim();
}
